var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size + 'px',"viewBox":"0 -960 960 960","width":_vm.size + 'px',"fill":"currentColor"}},[_c('path',{attrs:{"d":"m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }